import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect } from "react";

const getLangFromPath = (pathname: string): string => {
  if (pathname.startsWith('/ru')) return 'ru';
  if (pathname.startsWith('/us')) return 'us';
  if (pathname.startsWith('/en')) return 'en';
  return 'tr';
};

function App() {
  useEffect(() => {
    const pathname = window.location.pathname;
    const currentLang = getLangFromPath(pathname);
    if (i18n.language !== currentLang) {
      i18n.changeLanguage(currentLang);
    }

    // Domain-based redirect for ajanlaser.com
    const hostname = window.location.hostname;
    if (hostname === 'ajanlaser.com' && !pathname.startsWith('/en')) {
      if (pathname === '/' || pathname === '') {
        window.location.href = '/en';
      } else {
        const pathMap: Record<string, string> = {
          '/katalog': '/en/catalog',
          '/fuarlar': '/en/fairs',
          '/yerlesim-plani': '/en/layout-plan',
          '/kesim-kalinliklari': '/en/cutting-thickness',
          '/kapali-kabin': '/en/enclosed-cabin',
          '/gezer-kabin': '/en/gantry-cabin',
        };
        const englishPath = pathMap[pathname] || '/en';
        window.location.href = englishPath;
      }
    }
  }, []);

  // Sync language on initial render
  const initialLang = getLangFromPath(window.location.pathname);
  if (i18n.language !== initialLang) {
    i18n.changeLanguage(initialLang);
  }

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
